import type { ViewRule } from '../../../core/assistant/models/ViewRules';
import { normalizeFieldId } from '../fields/import-aliases';

export const SPAN_OVERLOAD_THRESHOLD = 8;
export const FLIGHT_RISK_COLORS = { low: '#dcfce7', medium: '#fef3c7', high: '#fee2e2' };

export function resolveOrgAnalyticValue(field: string, value: unknown): unknown {
  if (normalizeFieldId(field) !== 'flightRisk') return value;
  const risk = typeof value === 'string' ? value.trim().toLowerCase() : '';
  return Object.prototype.hasOwnProperty.call(FLIGHT_RISK_COLORS, risk) ? risk : null;
}

/** Compatibility at the read boundary: saved numeric flight-risk lenses are categorical. */
export function resolveOrgAnalyticRules(rules: ViewRule[]): ViewRule[] {
  return rules.map((rule) => {
    const field = rule.display.heatmap?.field ?? rule.display.colorByField?.field;
    if (!field || normalizeFieldId(field) !== 'flightRisk') return rule;
    const { heatmap: _heatmap, ...display } = rule.display;
    return {
      ...rule,
      display: {
        ...display,
        colorByField: {
          field: 'flightRisk',
          valueColors: { ...FLIGHT_RISK_COLORS, ...display.colorByField?.valueColors },
        },
      },
    };
  });
}
